import { useClientTranslations } from "../../lib/i18n/client";
import {
	getTrainingProgress,
	type TrainingItem as TrainingItemType,
} from "../../services/educationService";
import styles from "./RequiredTraining.module.css";
import { TrainingItem } from "./TrainingItem";

interface RequiredTrainingProps {
	items: TrainingItemType[];
}

export function RequiredTraining({ items }: RequiredTrainingProps) {
	const { t } = useClientTranslations("education");
	const { completed, total } = getTrainingProgress(items);

	return (
		<section className={styles.section}>
			<div className={styles.header}>
				<h2 className={styles.heading}>{t("training.heading")}</h2>
				<span className={styles.progress}>
					{t("training.progress", { completed, total })}
				</span>
			</div>
			<div className={styles.list}>
				{items.map((item) => (
					<TrainingItem key={item.id} item={item} />
				))}
			</div>
		</section>
	);
}
